import {
    isExtendedColor,
    isBackgroundColor,
    isTextColor,
    isCommonColor,
    isRootColor,
    isColorTint,
    isSystemColor,
    isColorShade,
} from '../../utils';
import { ColorOption, HoneycombThemeBase } from '../types';

export function getColor(theme: HoneycombThemeBase) {
    return (name: ColorOption) => {
        const { palette } = theme;
        const [first, second, third, fourth] = name.split('.');
        if (isExtendedColor(first)) {
            if (isColorShade(second)) {
                return palette[first][second];
            }
            if (second === 'tint' && isColorTint(third)) {
                return palette[first].tint[third];
            }
            if (second === 'contrastText') {
                return palette[first].contrastText;
            }
            return palette[first].base;
        }
        if (first === 'system' && isSystemColor(second)) {
            if (isColorShade(third)) {
                return palette.system[second][third];
            }
            if (third === 'tint' && isColorTint(fourth)) {
                return palette.system[second].tint[fourth];
            }
            if (fourth === 'contrastText') {
                return palette.system[second].contrastText;
            }
            return palette.system[second].base;
        }
        if (first === 'background' && isBackgroundColor(second)) {
            return palette.background[second];
        }
        if (first === 'text' && isTextColor(second)) {
            return palette.text[second];
        }
        if (first === 'common' && isCommonColor(second)) {
            return palette.common[second];
        }
        if (isRootColor(first)) {
            return palette[first];
        }
        return palette.common.black;
    };
}
